<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Sites",
  data() {
    return {};
  },
};
</script>
